export default {
  title: {
    en: 'Statistics',
  },
}
